module.exports = __webpack_public_path__ + "media/country_flags/kp-3996049d.png";